import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { formatDate, withParams } from '@telialt/utils/src/helpers';

import { PUBLIC_WEB_CONTENT_TEST_ID } from '../../../test-ids';
import {
    CategoriesList,
    CategoryLink,
    PublishDate,
    StyledArticleCategoryAndDate,
} from '../ContentBlogArticlePage.styles';
import { BlogArticlePageData } from '../model';

type Props = {
    categories: BlogArticlePageData['categories'];
    effectiveDate: string;
    $target: 'desktop' | 'mobile';
};

export const ArticleCategoryAndDate: FC<Props> = ({ categories, effectiveDate, $target }) => {
    const { t } = useTranslations();

    return (
        <StyledArticleCategoryAndDate $target={$target}>
            <CategoriesList>
                {categories.map((category) => (
                    <li key={category.id}>
                        <CategoryLink
                            href={category.href}
                            aria-label={withParams(t['blog.article_page.category_link.aria_label'], {
                                category: category.name,
                            })}
                            data-test={`${PUBLIC_WEB_CONTENT_TEST_ID.ARTICLE_CATEGORY_LINK}-${category.id}-${$target}`}
                            data-element="Link"
                            data-element-name={category.name}
                        >
                            {category.name}
                        </CategoryLink>
                    </li>
                ))}
            </CategoriesList>
            <PublishDate>{formatDate(effectiveDate)}</PublishDate>
        </StyledArticleCategoryAndDate>
    );
};
